import {
  Component,
  inject,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ResultsUtilsService } from '@app/modules/reports/services/results-utils.service';
import { ResultsState } from '@app/modules/reports/store/results.state';
import { Result } from '@app/modules/reports/types/result.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionsLocation,
  DataTableActionType,
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-result-search-results',
  imports: [TranslatePipe, DataTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './result-search-results.component.html',
})
export class ResultSearchResultsComponent implements OnInit {
  private dialogRef = inject(NgbActiveModal);
  private resultsUtilsService = inject(ResultsUtilsService);
  private store = inject(Store);

  public resultIds = signal<string[]>([]);
  protected isLoading = signal(true);

  protected dataTableConfiguration: DataTableConfiguration;

  private rows$: Observable<Result[]>;

  ngOnInit(): void {
    this.rows$ = this.store.select(ResultsState.getResultsByIds).pipe(
      map((getResultByIds) => getResultByIds(this.resultIds())),
      tap(() => this.isLoading.set(false))
    );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      actionsLocation: DataTableActionsLocation.RIGHT,
      tableHeadClasses: '',
      actionsClasses: 'text-end',
      columns: [
        {
          label: 'results.search.columns.barcode',
          property: 'kitId',
        },
        {
          label: 'results.search.columns.reports',
          property: 'reportIds.length',
        },
      ],
      singleActions: [
        {
          name: 'results.search.actions.openResultDetails',
          icon: 'fa-light fa-file',
          type: DataTableActionType.BUTTON,
          action: this.openResultDetails.bind(this),
        },
      ],
      rows$: this.rows$,
    };
  }

  private openResultDetails(event: MouseEvent, result: Result) {
    this.resultsUtilsService.openResultDetails(result.id);
    this.dismiss();
  }

  dismiss() {
    this.dialogRef.close();
  }
}
